import React, { useRef, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { SEARCH_WORD_SET } from '../../../../app/redux/actions/search';
import {
  APP_MENU_TOGGLE,
  APP_NAVIGATION_TOGGLE,
} from '../../../../app/redux/actions';

import {
  NavBarContainer,
  NameContainer,
  SearchWrapper,
  LogoWrapper,
  LogoutWrapper,
  IconWrapperLogout,
  FirstNav,
  SecondNav,
  SearchContainer,
} from './style';
import { CircleImage, Logo, MenuButton, SearchBar } from '../../../atoms';
import routes from '../../../../routes';
import compose from '../../../../utils/compose';
import { withMediaQueries } from '../../../../app/hoc/withMediaQueries';
import Icon from '../../../atoms/Icon';
import theme from '../../../theme';
import { ToastInfo } from '../../Toast';

const NavBarMobile = ({
  setSearchWord,
  menuToggle,
  navigationMobileToogle,
  username,
  menuLogo,
}) => {
  const navigate = useNavigate();
  const nameRef = useRef(null);
  const [search, setSearch] = useState('');
  const [showSearch, setShowSearch] = useState();

  const handleOnChangeSearch = (value) => {
    setSearch(value);
  };
  const handleOnSubmitSearch = (e) => {
    e.preventDefault();
    if (search?.trim()?.length > 2) {
      setSearch('');
      setSearchWord(search);
      navigate(routes.search.path);
    } else {
      toast.info(
        <ToastInfo
          title="Attenzione"
          body="La ricerca deve contenere almeno 3 caratteri"
        />,
        {
          toastId: 'infoSearchText',
        }
      );
    }
  };

  const changeLocation = (url) => {
    menuToggle();
    navigate(url);
  };

  return (
    <NavBarContainer>
      <FirstNav>
        <LogoWrapper>
          <Logo size={Logo.SIZE.SMALL} defaultLogo />
        </LogoWrapper>
        <SearchWrapper>
          <Icon
            type="search-sm"
            stroke={theme().colors.white}
            onClick={() => setShowSearch(true)}
          />
          <SearchContainer
            className={
              showSearch === undefined
                ? ''
                : showSearch
                ? 'slidein'
                : 'slideout'
            }
            nameOffset={nameRef?.current?.offsetLeft}
          >
            <SearchBar
              placeholder="Cerca"
              mobile
              value={search}
              onChange={handleOnChangeSearch}
              onSubmit={handleOnSubmitSearch}
              onClickClose={() => {
                setShowSearch(false);
                setSearch('');
              }}
              closeAlwaysVisible
              forceFocus={showSearch}
            />
          </SearchContainer>
        </SearchWrapper>
        <NameContainer
          onClick={() => navigate(routes.editProfile.path)}
          ref={nameRef}
        >
          <CircleImage name={username} src={username?.profile_pic} size={35} />
        </NameContainer>
        <LogoutWrapper onClick={() => changeLocation(routes.public.path)}>
          <IconWrapperLogout>
            <Icon type="arrow-circle-broken-left" size={20} fill="none" />
          </IconWrapperLogout>
        </LogoutWrapper>
      </FirstNav>
      <SecondNav>
        <LogoWrapper>
          <Logo
            size={Logo.SIZE.SMALL}
            onClick={() => changeLocation(routes.home.path)}
            src={menuLogo?.src}
            alt={menuLogo?.alt}
          />
        </LogoWrapper>
        <MenuButton handleOnClick={navigationMobileToogle} />
      </SecondNav>
    </NavBarContainer>
  );
};

NavBarMobile.propTypes = {
  // HOC withMediaQueries

  // HOC (connect, state)
  username: PropTypes.object,
  menuLogo: PropTypes.object,

  // HOC (connect, dispatch)
  setSearchWord: PropTypes.func,
  menuToggle: PropTypes.func.isRequired,
  navigationMobileToogle: PropTypes.func.isRequired,
};

const composed = compose(
  connect(
    (state) => ({
      username: state.user,
      menuLogo: state.home.menuLogo,
    }),
    (dispatch) => ({
      setSearchWord: (payload) =>
        dispatch({ type: SEARCH_WORD_SET, response: payload }),
      menuToggle: () => dispatch({ type: APP_MENU_TOGGLE }),
      navigationMobileToogle: () => dispatch({ type: APP_NAVIGATION_TOGGLE }),
    })
  ),
  withMediaQueries
)(NavBarMobile);
export default composed;
